import { h, Component } from 'preact';
import { sortObjectByOrder, accessNested, joinClasses } from 'utils/utils';
import HTML from 'components/core/html/html';
import Button from 'components/shared/button/button';
import Store from 'store/store';
import * as actions from 'store/actions';
import s from 'components/pages/hub/tiles.sss';

export default class Tiles extends Component {
	constructor(props) {
		super(props);

		this.renderGroup = this.renderGroup.bind(this);

		this.names = {};
	}

	renderGroup(group, groupIndex) {
		const articles = sortObjectByOrder(group);

		return (
			<div class={s.line}>
				{articles.map((article, index) => {
					let type = 'large';
					if (articles.length === 2) {
						type = 'medium';
					} else if (articles.length === 3) {
						type = 'small';
					}

					return this.renderArticle(article, type, groupIndex, index);
				})}
			</div>
		);
	}

	renderArticle(data, type, groupIndex, articleIndex) {
		const {
			media   = {},
			date    = '',
			title   = '',
			prod    = '',
			blurb   = '',
			buttons = {}
		} = data;

		let showGradient = false;
		let maxHeight    = 96;

		const name = this.names['group' + groupIndex + 'article' + articleIndex];
		const isDesktop = this.props.client.deviceSize === 'desktop';
		const isDesktopSmallTile = isDesktop && type === 'small';
		const isDesktopLargeTile = isDesktop && type === 'large';

		if (isDesktopSmallTile) {
			maxHeight = 72;
		}

		if (name) {
			let nameHeight = getComputedStyle(name).height;
			let height = nameHeight.substring(0, nameHeight.length - 2);

			if (height > maxHeight && !isDesktopLargeTile) {
				showGradient = true;
			}
		}

		return (
			<article class={joinClasses(s.tile, s[type])}>
				{this.renderMedia(media)}
				<div class={s.info}>
					<HTML tag='h3' class={s.date} markdown>{date}</HTML>
					<div class={joinClasses(s.name, showGradient && s.showGradient)} ref={ref => this.names['group' + groupIndex + 'article' + articleIndex] = ref}>
						<HTML
							tag="h4"
							markdown
							content={title}
						/>
					</div>
					<HTML tag='p' class={s.prod} markdown>{prod}</HTML>
					<HTML tag='p' class={s.blurb} markdown>{blurb}</HTML>
					<div class={s.buttons}>
						{Object.values(buttons).map(button => {
							return <Button data={button} client={this.props.client} extraOnClick={() => {
								Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'tile-click', 'hub', title + '_' + button.label);
							}}/>;
						})}
					</div>
				</div>
			</article>
		);
	}

	renderMedia(data) {
		const {
			src       = {},
			alt       = '',
			ariaLabel = ''
		} = data;

		const deviceSize = accessNested(this.props, 'client.deviceSize');
		const orientation = accessNested(this.props, 'client.orientation');
		const isMobileLandscape = deviceSize === 'mobile' && orientation === 'landscape';
		let resolution = deviceSize === 'desktop' ? 'desktop' : 'mobile';
		if (isMobileLandscape) resolution = 'mobileLandscape';
		const mediaSrc   = src[resolution];
		const isVideo    = mediaSrc.endsWith('mp4');

		return (
			<div class={s.media}>
				{isVideo ?
					<video class={s.video} src={mediaSrc} ariaLabel={ariaLabel} controls={false} autoplay muted />
					: <img class={s.image} src={mediaSrc} alt={alt} />
				}
			</div>
		);
	}

	render({ data }) {
		const {
			title      = '',
			tileGroups = {}
		} = data;

		const groups = sortObjectByOrder(tileGroups);

		return (
			<section class={s.section}>
				<h2 class={s.title}>
					<span>{title}</span>
				</h2>
				<div class={s.tiles}>
					{groups.map(this.renderGroup)}
				</div>
			</section>
		);
	}
}
